import GPAContainer from "./GPA";
export { GPAContainer };
